(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.score = 0;
        this.status = "playing";
        this.highscore = Number(localStorage.getItem("highscore")) || 0;
        if (initialState) this.board = initialState.map(function(row) {
            return row.slice();
        });
        else this.start();
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "_updateHighscore",
            value: function _updateHighscore() {
                if (this.score > this.highscore) {
                    this.highscore = this.score;
                    localStorage.setItem("highscore", this.highscore);
                }
            }
        },
        {
            // Add Random Tile on the board
            key: "_addRandomTile",
            value: function _addRandomTile() {
                var emptyCells = [];
                for(var i = 0; i < this.board.length; i++){
                    for(var j = 0; j < this.board[i].length; j++)if (this.board[i][j] === 0) emptyCells.push([
                        i,
                        j
                    ]);
                }
                if (emptyCells.length === 0) return;
                var _emptyCells_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyCells[Math.floor(Math.random() * emptyCells.length)], 2), row = _emptyCells_Math_floor[0], col = _emptyCells_Math_floor[1];
                var newValue = Math.random() < 0.9 ? 2 : 4;
                this.board[row][col] = newValue;
            }
        },
        {
            // Merge Row
            key: "_slideAndMergeRow",
            value: function _slideAndMergeRow(row) {
                var nonZero = row.filter(function(x) {
                    return x !== 0;
                });
                for(var i = 0; i < nonZero.length; i++)if (nonZero[i] === nonZero[i + 1]) {
                    nonZero[i] *= 2;
                    nonZero[i + 1] = 0;
                    this.score += nonZero[i];
                    this._updateHighscore();
                }
                var merged = nonZero.filter(function(x) {
                    return x !== 0;
                });
                while(merged.length < 4)merged.push(0);
                return merged;
            }
        },
        {
            // Check if two arrays are equal
            key: "arraysEqual",
            value: function arraysEqual(a, b) {
                return a.length === b.length && a.every(function(v, i) {
                    return v === b[i];
                });
            }
        },
        {
            // Transpose Matrix
            key: "transpose",
            value: function transpose() {
                var matrix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.board;
                return matrix[0].map(function(_, colIndex) {
                    return matrix.map(function(row) {
                        return row[colIndex];
                    });
                });
            }
        },
        {
            key: "move",
            value: function move(direction) {
                var oldBoard = this.getState();
                var newBoard;
                switch(direction){
                    case "left":
                        newBoard = this._moveLeftInternal();
                        break;
                    case "right":
                        newBoard = this._reverseBoard();
                        newBoard = this._moveLeftInternal(newBoard);
                        newBoard = this._reverseBoard(newBoard);
                        break;
                    case "up":
                        newBoard = this.transpose();
                        newBoard = this._moveLeftInternal(newBoard);
                        newBoard = this.transpose(newBoard);
                        break;
                    case "down":
                        newBoard = this.transpose();
                        newBoard = this._reverseBoard(newBoard);
                        newBoard = this._moveLeftInternal(newBoard);
                        newBoard = this._reverseBoard(newBoard);
                        newBoard = this.transpose(newBoard);
                        break;
                }
                if (!this._boardsEqual(oldBoard, newBoard)) {
                    this.board = newBoard;
                    this._addRandomTile();
                }
                this.checkGameStatus();
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                this.move("left");
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                this.move("right");
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.move("up");
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.move("down");
            }
        },
        {
            key: "_moveLeftInternal",
            value: function _moveLeftInternal() {
                var _this = this;
                var board = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.board;
                return board.map(function(row) {
                    return _this._slideAndMergeRow(row);
                });
            }
        },
        {
            key: "_reverseBoard",
            value: function _reverseBoard() {
                var board = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.board;
                return board.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                });
            }
        },
        {
            key: "_boardsEqual",
            value: function _boardsEqual(a, b) {
                var _this = this;
                return a.every(function(row, i) {
                    return _this.arraysEqual(row, b[i]);
                });
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.board.map(function(row) {
                    return row.slice();
                });
            }
        },
        {
            key: "getHighscore",
            value: function getHighscore() {
                return this.highscore;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "checkGameStatus",
            value: function checkGameStatus() {
                if (this.checkGameOver()) this.status = "lose";
                else if (this.checkGameWin()) this.status = "win";
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.board = Array(4).fill().map(function() {
                    return Array(4).fill(0);
                });
                this.score = 0;
                this.status = "playing";
                this._addRandomTile();
                this._addRandomTile();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.start();
            }
        },
        {
            key: "checkGameWin",
            value: function checkGameWin() {
                return this.board.some(function(row) {
                    return row.includes(2048);
                });
            }
        },
        {
            key: "checkGameOver",
            value: function checkGameOver() {
                if (this.board.flat().includes(0)) return false;
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
                    var current = this.board[i][j];
                    if (i < 3 && this.board[i + 1][j] === current || j < 3 && this.board[i][j + 1] === current) return false;
                }
                return true;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$isAnimating = false;
var $197cd56b15c33885$var$startX = 0;
var $197cd56b15c33885$var$startY = 0;
var $197cd56b15c33885$var$endX = 0;
var $197cd56b15c33885$var$endY = 0;
var $197cd56b15c33885$var$SWIPE_THRESHOLD = 30;
var $197cd56b15c33885$var$cells = document.querySelectorAll(".field-cell");
var $197cd56b15c33885$var$startBtn = document.querySelector(".button.start");
var $197cd56b15c33885$var$scoreEl = document.querySelector(".game-score");
var $197cd56b15c33885$var$bestScoreEl = document.querySelector(".best-score");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$boardEl = document.querySelector(".game-field");
function $197cd56b15c33885$var$updateStartButton() {
    $197cd56b15c33885$var$startBtn.classList.remove("start");
    $197cd56b15c33885$var$startBtn.classList.add("restart");
    $197cd56b15c33885$var$startBtn.textContent = "Restart";
    $197cd56b15c33885$var$messageStart.classList.add("hidden");
}
function $197cd56b15c33885$var$hideMessages() {
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
}
function $197cd56b15c33885$var$showGameStatus() {
    var status = $197cd56b15c33885$var$game.getStatus();
    if (status === "win") $197cd56b15c33885$var$messageWin.classList.remove("hidden");
    if (status === "lose") $197cd56b15c33885$var$messageLose.classList.remove("hidden");
}
function $197cd56b15c33885$var$render() {
    var board = $197cd56b15c33885$var$game.getState();
    board.forEach(function(row, i) {
        row.forEach(function(value, j) {
            var index = i * 4 + j;
            var cell = $197cd56b15c33885$var$cells[index];
            cell.textContent = value || "";
            cell.className = "field-cell";
            if (value) cell.classList.add("field-cell--".concat(value));
        });
    });
    $197cd56b15c33885$var$scoreEl.textContent = $197cd56b15c33885$var$game.getScore();
    $197cd56b15c33885$var$bestScoreEl.textContent = $197cd56b15c33885$var$game.getHighscore();
    $197cd56b15c33885$var$hideMessages();
    $197cd56b15c33885$var$showGameStatus();
}
document.addEventListener("keydown", function(e) {
    if ($197cd56b15c33885$var$isAnimating) return;
    $197cd56b15c33885$var$isAnimating = true;
    setTimeout(function() {
        return $197cd56b15c33885$var$isAnimating = false;
    }, 100);
    $197cd56b15c33885$var$updateStartButton();
    if ([
        "win",
        "lose"
    ].includes($197cd56b15c33885$var$game.getStatus())) return;
    var actions = {
        ArrowLeft: function() {
            return $197cd56b15c33885$var$game.moveLeft();
        },
        ArrowRight: function() {
            return $197cd56b15c33885$var$game.moveRight();
        },
        ArrowUp: function() {
            return $197cd56b15c33885$var$game.moveUp();
        },
        ArrowDown: function() {
            return $197cd56b15c33885$var$game.moveDown();
        }
    };
    var action = actions[e.key];
    if (!action) return;
    action();
    $197cd56b15c33885$var$render();
});
function $197cd56b15c33885$var$handleSwipe(dx, dy) {
    $197cd56b15c33885$var$updateStartButton();
    if ([
        "win",
        "lose"
    ].includes($197cd56b15c33885$var$game.getStatus())) return;
    if (Math.abs(dx) > Math.abs(dy)) {
        if (dx > $197cd56b15c33885$var$SWIPE_THRESHOLD) $197cd56b15c33885$var$game.moveRight();
        else if (dx < -$197cd56b15c33885$var$SWIPE_THRESHOLD) $197cd56b15c33885$var$game.moveLeft();
    } else {
        if (dy > $197cd56b15c33885$var$SWIPE_THRESHOLD) $197cd56b15c33885$var$game.moveDown();
        else if (dy < -$197cd56b15c33885$var$SWIPE_THRESHOLD) $197cd56b15c33885$var$game.moveUp();
    }
    $197cd56b15c33885$var$render();
}
// Touch
$197cd56b15c33885$var$boardEl.addEventListener("touchstart", function(e) {
    e.preventDefault();
    var touch = e.touches[0];
    $197cd56b15c33885$var$startX = touch.clientX;
    $197cd56b15c33885$var$startY = touch.clientY;
}, {
    passive: false
});
$197cd56b15c33885$var$boardEl.addEventListener("touchend", function(e) {
    e.preventDefault();
    var touch = e.changedTouches[0];
    $197cd56b15c33885$var$endX = touch.clientX;
    $197cd56b15c33885$var$endY = touch.clientY;
    $197cd56b15c33885$var$handleSwipe($197cd56b15c33885$var$endX - $197cd56b15c33885$var$startX, $197cd56b15c33885$var$endY - $197cd56b15c33885$var$startY);
}, {
    passive: false
});
// Mouse
var $197cd56b15c33885$var$isMouseDown = false;
$197cd56b15c33885$var$boardEl.addEventListener("mousedown", function(e) {
    $197cd56b15c33885$var$isMouseDown = true;
    $197cd56b15c33885$var$startX = e.clientX;
    $197cd56b15c33885$var$startY = e.clientY;
});
$197cd56b15c33885$var$boardEl.addEventListener("mouseup", function(e) {
    if (!$197cd56b15c33885$var$isMouseDown) return;
    $197cd56b15c33885$var$isMouseDown = false;
    $197cd56b15c33885$var$endX = e.clientX;
    $197cd56b15c33885$var$endY = e.clientY;
    $197cd56b15c33885$var$handleSwipe($197cd56b15c33885$var$endX - $197cd56b15c33885$var$startX, $197cd56b15c33885$var$endY - $197cd56b15c33885$var$startY);
});
$197cd56b15c33885$var$startBtn.addEventListener("click", function() {
    $197cd56b15c33885$var$updateStartButton();
    $197cd56b15c33885$var$game.start();
    $197cd56b15c33885$var$render();
});
$197cd56b15c33885$var$render();

})();
//# sourceMappingURL=index.c85fbec2.js.map
